import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterHasValue',
  standalone: false
})
export class FilterHasValuePipe implements PipeTransform {
  transform<T extends Record<string, any>>(items: T[], filters: { [k: string]: boolean }) {
    return (items || []).filter(item => Object.keys(filters || {}).filter(key => !!item[key] !== filters[key]).length === 0);
  }
}
